export default __webpack_public_path__ + "static/media/kyselyt-white.60544466.svg";